// Seção nomeada do Dashboard (Engajamento / Operação): título com
// ícone + descrição curta e divisor — agrupa as métricas por
// público (cliente vs saúde da operação).
import type { LucideIcon } from "lucide-react"

import { Separator } from "@/components/ui/separator"

interface DashboardSectionProps
  extends React.PropsWithChildren {
  icon: LucideIcon
  title: string
  description: string
}

export const DashboardSection = ({
  icon: Icon,
  title,
  description,
  children,
}: DashboardSectionProps) => (
  <section
    aria-label={title}
    className="flex flex-col gap-4"
  >
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Icon
          aria-hidden="true"
          className="size-4 text-muted-foreground"
        />
        <h2 className="text-lg font-semibold tracking-tight">
          {title}
        </h2>
      </div>
      <p className="text-sm text-muted-foreground">
        {description}
      </p>
      <Separator className="mt-1" />
    </div>
    {children}
  </section>
)
